import { isEmpty, isString } from 'lodash';
import { DATA_STATES } from '@/store/consts';
import { STATE_KEYS } from './state';
import { DEFAULT_CONFIGURATION_STEPS,
  SALESFORCE_WIDGET_CONFIGURATION_STEPS,
  WIDGET_ID_KEYS } from './helper';
import { salesforceWidgetService } from '../../../../services/widget/SalesforceWidgetService';
import { widgetService } from '../../../../services/widget/WidgetService';

const MUTATION_TYPES = {
  SET_CURRENT_WIDGET_ID: 'setCurrentWidgetId',
  SET_DATA_STATE: 'setDataState',
  SET_WIDGETS: 'setWidgets',
  SET_WIDGET_CONFIGURATION_STEP_IDX: 'setConfigurationStepIndex',
  SET_WIDGET_CONNECTION: 'setWidgetConnection',
  SET_WIDGET_VIEW: 'setWidgetView',
  SET_WIDGET_LAYOUT: 'setWidgetLayout',
  SET_WIDGET_CUSTOMIZATION: 'setWidgetCustomization',
  SET_CONNECTION_TEST_RESULT: 'setWidgetConnectionTestResult',
  SET_DELETE_RESPONSE: 'setWidgetDeleteConnectionResponse',
  SET_EXPLORER_RESPONSE: 'setWidgetExplorerResponse',
  RESET: 'reset',
};

const mutations = {
  [MUTATION_TYPES.RESET](state) {
    state[STATE_KEYS.CURRENT_SERVICE] = widgetService;
    state[STATE_KEYS.ALL_CONFIGURATION_STEPS] = DEFAULT_CONFIGURATION_STEPS;
    state[STATE_KEYS.CONFIGURATION_STEP_IDX] = 0;
    state[STATE_KEYS.LAST_UPDATE_TIME] = null;
    state[STATE_KEYS.WIDGET_CONNECTION] = null;
    state[STATE_KEYS.WIDGET_VIEW] = {};
    state[STATE_KEYS.WIDGET_LAYOUT] = {};
    state[STATE_KEYS.CONNECTION_TEST_RESULT] = null;
    state[STATE_KEYS.DELETE_RESPONSE] = null;
    state[STATE_KEYS.EXPLORER_RESPONSE] = null;
    state[STATE_KEYS.CURRENT_WIDGET_ID] = null;
  },
  [MUTATION_TYPES.SET_CURRENT_WIDGET_ID](state, widgetId) {
    if ((isString(widgetId) && !isEmpty(widgetId))) {
      switch (widgetId) {
        case WIDGET_ID_KEYS.SALESFORCE:
          state[STATE_KEYS.ALL_CONFIGURATION_STEPS] = SALESFORCE_WIDGET_CONFIGURATION_STEPS;
          state[STATE_KEYS.CURRENT_SERVICE] = salesforceWidgetService;
          break;
        default:
          state[STATE_KEYS.ALL_CONFIGURATION_STEPS] = DEFAULT_CONFIGURATION_STEPS;
          state[STATE_KEYS.CURRENT_SERVICE] = widgetService;
      }
      state[STATE_KEYS.CONFIGURATION_STEP_IDX] = 0;
      state[STATE_KEYS.LAST_UPDATE_TIME] = null;
      state[STATE_KEYS.WIDGET_CONNECTION] = null;
      state[STATE_KEYS.WIDGET_VIEW] = {};
      state[STATE_KEYS.WIDGET_LAYOUT] = {};
      state[STATE_KEYS.CONNECTION_TEST_RESULT] = null;
      state[STATE_KEYS.DELETE_RESPONSE] = null;
      state[STATE_KEYS.EXPLORER_RESPONSE] = null;
      state[STATE_KEYS.CURRENT_WIDGET_ID] = widgetId;
    } else {
      console.error(`Could not set the incorrect widget id: ${widgetId}`);
    }
  },
  [MUTATION_TYPES.SET_DATA_STATE](state, dataState) {
    switch (dataState) {
      case DATA_STATES.SUCCESS: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = Date.now();
        break;
      }
      case DATA_STATES.ERROR: {
        state[STATE_KEYS.ERROR_COUNT] += 1;
        break;
      }
      case DATA_STATES.NONE: {
        state[STATE_KEYS.ERROR_COUNT] = 0;
        state[STATE_KEYS.LAST_UPDATE_TIME] = null;
        break;
      }
      default:
        break;
    }
    state[STATE_KEYS.DATA_STATE] = dataState;
  },
  [MUTATION_TYPES.SET_WIDGETS](state, widgets) {
    state[STATE_KEYS.WIDGETS] = widgets;
  },
  [MUTATION_TYPES.SET_WIDGET_CONFIGURATION_STEP_IDX](state, stepIdx) {
    state[STATE_KEYS.CONFIGURATION_STEP_IDX] = stepIdx;
  },
  [MUTATION_TYPES.SET_WIDGET_CONNECTION](state, configFields) {
    state[STATE_KEYS.WIDGET_CONNECTION] = configFields;
  },
  [MUTATION_TYPES.SET_WIDGET_CUSTOMIZATION](state, customizationFields) {
    state[STATE_KEYS.WIDGET_CUSTOMIZATION] = customizationFields;
  },
  [MUTATION_TYPES.SET_WIDGET_VIEW](state, widgetView) {
    state[STATE_KEYS.WIDGET_VIEW] = widgetView;
  },
  [MUTATION_TYPES.SET_WIDGET_LAYOUT](state, widgetLayout) {
    state[STATE_KEYS.WIDGET_LAYOUT] = widgetLayout;
  },
  [MUTATION_TYPES.SET_CONNECTION_TEST_RESULT](state, result) {
    state[STATE_KEYS.CONNECTION_TEST_RESULT] = result;
  },
  [MUTATION_TYPES.SET_DELETE_RESPONSE](state, response) {
    state[STATE_KEYS.DELETE_RESPONSE] = response;
  },
  [MUTATION_TYPES.SET_EXPLORER_RESPONSE](state, response) {
    state[STATE_KEYS.EXPLORER_RESPONSE] = response;
  },
};

export {
  mutations,
  MUTATION_TYPES,
};
